import { keepOnlyUtmParams } from "common/bit/utils/utmParams"
import { useEffect, useRef, useState } from "react"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"

const StyledIframe = styled.iframe<{ $height?: number }>`
  width: 100%;
  height: ${(p) => p?.$height || "1450"}px;
  /* margin: -40px -20px -20px -20px; */
  position: relative;

  ${(p) => p.theme.breakpoints.down("sm")} {
    height: 2300px;
  }
`

type Props = {
  url: string
}
const ScheduleIframe = ({ url }: Props) => {
  const [utmString, setUtmString] = useState("")
  const [height, setHeight] = useState(0)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  useEffect(() => {
    setUtmString(
      "&" +
        keepOnlyUtmParams(
          window.location.href.split("?")[1] || "" || window.location.search
        )
    )
  }, [])

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== new URL(url).origin) {
        // Ignore messages from unknown origins
        return
      }
      console.log("Message received from iframe:", event.data)
      setHeight(event?.data?.height || 0)
    }

    window.addEventListener("message", handleMessage)

    return () => {
      window.removeEventListener("message", handleMessage)
    }
  }, [])

  return (
    <StyledPageWrapper $padding={"0"}>
      <StyledIframe
        src={`${url || ""}${utmString}`}
        frameBorder={0}
        ref={iframeRef}
        $height={height}
      />
    </StyledPageWrapper>
  )
}

export default ScheduleIframe
